"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Restrict = function (_React$Component) {
	_inherits(Restrict, _React$Component);

	function Restrict() {
		_classCallCheck(this, Restrict);

		return _possibleConstructorReturn(this, (Restrict.__proto__ || Object.getPrototypeOf(Restrict)).apply(this, arguments));
	}

	_createClass(Restrict, [{
		key: "render",
		value: function render() {
			var _props = this.props,
			    access_right = _props.access_right,
			    currentUser = _props.currentUser;

			if (access_right == null) {
				return this.props.children;
			} else {
				if (currentUser != null) {
					if (Object.keys(currentUser.data.ACCESS_RIGHTS).indexOf(access_right) >= 0) {
						return this.props.children;
					}
				}
				return null;
			}
		}
	}]);

	return Restrict;
}(_react2.default.Component);

exports.default = (0, _redux.compose)((0, _reactRedux.connect)(function (state) {
	return {
		currentUser: state.currentUser
	};
}))(Restrict);